import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=7d389756&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=7d389756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d389756",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutListNavigationDrawer: require('/home/runner/work/loja/loja/components/Layout/ListNavigationDrawer.vue').default,CartNavigationDrawer: require('/home/runner/work/loja/loja/components/CartNavigationDrawer.vue').default,CartEmpty: require('/home/runner/work/loja/loja/components/CartEmpty.vue').default,DarkMode: require('/home/runner/work/loja/loja/components/DarkMode.vue').default,ContaLogin: require('/home/runner/work/loja/loja/components/ContaLogin.vue').default,LayoutListAppBar: require('/home/runner/work/loja/loja/components/Layout/ListAppBar.vue').default})
